import { gql } from '@apollo/client';

export const GET_HIGHLIGHT_COLLECTION = gql`
    query getHighlightCollections($input: GetHighlightCollectionInput!) {
        getHighlightCollections(input: $input) {
            id
            title
            subTitle
            gender
            imageUrl
            url
            buttonCaption
            creator
            created
            updater
            updated
        }
    }
`;
